module.exports = __webpack_public_path__ + "img/4040.5d7bd395.png";